
function BuchungsbedingungenPage() {
  return (
    <div className="min-h-screen bg-white py-16 px-4">
      <article className="max-w-[720px] mx-auto" style={{ lineHeight: 1.8 }}>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
          Buchungsbedingungen
        </h1>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">1. Geltung</h2>
          <p className="mb-4 text-gray-700">
            Diese Bedingungen gelten für alle Platzbuchungen beim Sportverein Heinersreuth 1921 e.V.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">2. Vertragsschluss</h2>
          <p className="mb-4 text-gray-700">
            Mit Bestätigung der Buchung auf der Website oder per E-Mail kommt der Vertrag zustande.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">3. Preise und Zahlung</h2>
          <p className="mb-4 text-gray-700">
            Es gelten die bei der Buchung ausgewiesenen Preise. Die Zahlung erfolgt gemäß Auswahl online über PayPal bzw. Kreditkarte über PayPal Checkout oder vor Ort nach Vereinbarung.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">4. Stornierung und Rückerstattung</h2>
          <p className="mb-4 text-gray-700">
            Buchungen können jederzeit storniert werden. Die Rückerstattung richtet sich nach dem Zeitpunkt der Stornierung:
          </p>
          <ul className="mb-4 text-gray-700 list-disc pl-6 space-y-2">
            <li><strong>Mehr als 4 Stunden vor Buchungsbeginn:</strong> Vollständige Rückerstattung (100%)</li>
            <li><strong>Zwischen 2 und 4 Stunden vor Buchungsbeginn:</strong> Teilweise Rückerstattung (50%)</li>
            <li><strong>Weniger als 2 Stunden vor Buchungsbeginn:</strong> Keine Rückerstattung (0%)</li>
          </ul>
          <p className="mb-4 text-gray-700">
            Nichterscheinen wird wie eine Stornierung weniger als 2 Stunden vor Buchungsbeginn behandelt. Der volle Buchungspreis wird berechnet.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">5. Widerruf</h2>
          <p className="mb-4 text-gray-700">
            Für Freizeit-Dienstleistungen mit festem Termin besteht kein Widerrufsrecht (§ 312g Abs. 2 Nr. 9 BGB).
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">6. Nutzung und Hausordnung</h2>
          <p className="mb-4 text-gray-700">
            Die Plätze dürfen nur im gebuchten Zeitfenster genutzt werden. Den Anweisungen des Vereins/Personals ist Folge zu leisten. Schäden sind unverzüglich zu melden; Verursacher haften für entstandene Schäden.
          </p>

          <p className="mb-4 text-gray-700">
            <strong>Hinweis zur Videoüberwachung (Sicherheitskameras):</strong> Zum Schutz von Personen, zur Wahrung des Hausrechts sowie zur Verhinderung und Aufklärung von Vandalismus, Diebstahl und sonstigen Sicherheitsvorfällen werden auf dem Gelände der Sportanlage öffentlich zugängliche Bereiche per Videokamera überwacht.
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO i. V. m. § 4 BDSG (berechtigtes Interesse an der Sicherung der Anlage und Beweissicherung).
          </p>

          <p className="mb-4 text-gray-700">
            Die Videoüberwachung ist vor Ort durch entsprechende Hinweisschilder kenntlich gemacht. Weitere Informationen (insb. Verantwortlicher/Kontakt, Zwecke, Speicherdauer bzw. Kriterien, Empfänger, Betroffenenrechte und Beschwerdemöglichkeit) sind den Datenschutzhinweisen vor Ort sowie den entsprechenden Datenschutzhinweisen des Vereins zu entnehmen.
            Aufzeichnungen werden grundsätzlich nur so lange gespeichert, wie dies zur Zweckerreichung erforderlich ist; bei konkreten Vorfällen kann eine längere Aufbewahrung bis zur abschließenden Klärung/Beweissicherung erfolgen.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">7. Haftung</h2>
          <p className="mb-4 text-gray-700">
            Der Verein haftet für Vorsatz und grobe Fahrlässigkeit; bei Verletzung wesentlicher Pflichten ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">8. Kontakt</h2>
          <p className="mb-4 text-gray-700">
            Sportverein Heinersreuth 1921 e.V., Bayreuther Str. 47, 95500 Heinersreuth, E-Mail: <a href="mailto:info@sv-heinersreuth.de" className="text-red-600 hover:text-red-700 hover:underline transition-colors">info@svheinersreuth-padel.de</a>
          </p>
        </div>

        <p className="text-sm text-slate-600 italic mt-8">
          Stand: 30.11.2025
        </p>
      </article>
    </div>
  );
}

export default BuchungsbedingungenPage;